import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MotoresTransmissaoTimeTableModel } from 'src/app/models/MotoresTransmissaoTimeTable';
import { MotoresTransmissaoUpdateModel } from 'src/app/models/MotoresTransmissaoUpdateModel';
import { MotoresTransmissaoService } from 'src/app/services/motores-transmissao/motores-transmissao.service';

@Component({
  selector: 'app-motores-transmissao-integration-form',
  templateUrl: './motores-transmissao-integration-form.component.html',
  styleUrl: './motores-transmissao-integration-form.component.css'
})
export class MotoresTransmissaoIntegrationFormComponent implements OnInit {

  timeTableIsVisible: boolean = false;

  sharedMotoresTransmissaoTrip!: MotoresTransmissaoTimeTableModel | null

  @Input() dockIdReceived: number | null = null;

  dockNumber: number = 0;

  constructor(private readonly motoresTransmissaoService: MotoresTransmissaoService,
    private readonly route: ActivatedRoute) { }

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      const dockIdFromUrl = +params['id'];
      if (dockIdFromUrl) {
        const dockMap = new Map<number, number>([
          [51, 1],
          [52, 2],
          [53, 3],
          [54, 4]
        ]);

        const mapped = dockMap.get(dockIdFromUrl);
        this.dockNumber = mapped ?? 0;
      }
    });
  }

  handleTripSelection(data: any) {
    this.sharedMotoresTransmissaoTrip = data
  }

  shareTripData() {

    if (!this.sharedMotoresTransmissaoTrip) { return alert("Selecione uma viagem da time-table antes de salvar!") }

    const payload: MotoresTransmissaoUpdateModel = {
      dockId: this.dockIdReceived!,
      tripId: this.sharedMotoresTransmissaoTrip!.id!
    }

    this.motoresTransmissaoService.updateEngineAndTransmissionTripsTable(payload).subscribe({
      next: () => {
        alert("Viagem atualizada")
      },
      error: (error) => {
        console.error("Erro ao atualizar dados: ", error);
        alert("Erro ao atualizar viagem");
      },
    })
  }

  clearFields() {
    this.sharedMotoresTransmissaoTrip = {
      id: null,
      trip: null,
      processDescription: null,
      arrivalTimeSLA: null,
      departureTimeSLA: null,
      extra: null
    }
  }

  togglePlanning() {
    this.timeTableIsVisible = !this.timeTableIsVisible
  }
}
